import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const postForm = (path, data) => axios.post(`${API}${path}`, data);
